import { 
  phoneAdjectives, phoneNouns, phoneSuffixes,
  companyAdjectives, companyNouns,
  firstNames, lastNames
} from './nameData';

export function generatePhoneName(): string {
  let name: string;
  let attempts = 0;
  
  do {
    const adj = phoneAdjectives[Math.floor(Math.random() * phoneAdjectives.length)];
    const noun = phoneNouns[Math.floor(Math.random() * phoneNouns.length)];
    
    // Sometimes skip suffix to keep name shorter
    if (Math.random() < 0.6) {
      const suffix = phoneSuffixes[Math.floor(Math.random() * phoneSuffixes.length)];
      name = `${adj} ${noun} ${suffix}`;
    } else {
      name = `${adj} ${noun}`;
    }
    
    attempts++;
  } while (name.length >= 10 && attempts < 20);
  
  // Fallback: if still too long, use just noun + suffix
  if (name.length >= 10) {
    const noun = phoneNouns[Math.floor(Math.random() * phoneNouns.length)];
    const suffix = phoneSuffixes[Math.floor(Math.random() * phoneSuffixes.length)];
    name = `${noun} ${suffix}`;
  }
  
  return name;
}

export function generateCompanyName(): string {
  let name: string;
  let attempts = 0;
  
  do {
    const adj = companyAdjectives[Math.floor(Math.random() * companyAdjectives.length)];
    const noun = companyNouns[Math.floor(Math.random() * companyNouns.length)];
    name = `${adj} ${noun}`;
    attempts++;
  } while (name.length >= 12 && attempts < 20);
  
  // Fallback: if still too long, use just noun
  if (name.length >= 12) {
    const noun = companyNouns[Math.floor(Math.random() * companyNouns.length)];
    name = noun;
  }
  
  return name;
}

export function generateCEOName(): string {
  const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
  const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
  return `${firstName} ${lastName}`;
}